export const ERROR_SAVE_STICKER = {
  pt: "Erro ao salvar o adesivo",
  es: "Error al guardar el adhesivo",
  en: "Error saving sticker",
};

export const LOGO = {
  pt: "logotipo",
  es: "logotipo",
  en: "logo",
};

export const CODE_LABEL = {
  pt: "Código",
  es: "Código",
  en: "Code",
};

export const DOWNLOAD = {
  pt: "Download",
  es: "Descargar",
  en: "Download",
};

export const STICKER = {
  pt: "Adesivo Completo",
  es: "Adhesivo Completo",
  en: "Full Sticker",
};

export const ERROR_QRCODE = {
  pt: "Erro ao gerar o QR Code",
  es: "Error al generar el QR Code",
  en: "Error generating QR Code",
};
